import { Grid, Box, useTheme, useMediaQuery } from '@material-ui/core';
import { ShortBody } from 'components/Typography';
import messages from 'containers/SignupPages/AuthByContractEpargnFailed/messages';
import { WrapperBox } from 'containers/SignupPages/AuthByContractEpargnFailed/style';
import { translate } from 'helpers/intl';
import { AssuranceIcon } from 'images';
import { sanlamBlue } from 'Material-UI/colors';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

const HelpBox = (props: { intl: IntlShape }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  return (
    <WrapperBox matches={matches}>
      <Box padding={2}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Grid container alignItems="center" spacing={2}>
              <img src={AssuranceIcon.helpIconLightBlue} alt="help icon"></img>
              <ShortBody
                weight="500"
                color={sanlamBlue}
                style={{ margin: '0 8px' }}
              >
                {translate({ ...messages.need_help }, props)}
              </ShortBody>
            </Grid>
          </Grid>
          <Grid item>
            <Box paddingX={4}>
              <ShortBody weight="400">
                {translate({ ...messages.helpMessage }, props)}
              </ShortBody>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </WrapperBox>
  );
};

export default injectIntl(HelpBox);
